import AddToCartButton from "./AddToCartButton";
import BackButton from "./BackButton";
import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import ProductNotes from "./ProductNotes";
import DeliveryAndReturns from "./DeliveryAndReturns";
import ProductImagesFullScreen from "./ProductImagesFullScreen";
import Head from "next/head";
import Metatags from "./Metatags";
import ProductDetails from "./ProductDetails";
import React from "react";
import SizeAndFit from "./SizeAndFit";
import SustainabilityCredentials from "./SustainabilityCredentials";
import TrustBar from "./TrustBar";
import getConfig from "../core/config";
import { useRouter } from "next/router";
import ProductImagesDesktop from "./ProductImagesDesktop";
import ProductImagesMobile from "./ProductImagesMobile";
import BodyText from "./BodyText";
import ProductSchema from "./ProductSchema";

function Product({ product, metaDescription }) {
  const {
    query: { slug },
  } = useRouter();
  const isInstoreOnly = product.salesChannel === "instore";

  const title = `${product.brand.name} ${product.title} ${product.garmentId}: New & Pre-loved ${product.rootCategory.name} On Sale`;

  return (
    <>
      <Head>
        <title>{title}</title>
        <link rel="canonical" href={`${getConfig("ORIGIN")}/product/${slug}`} />
        {isInstoreOnly && <meta name="robots" content="noindex" />}
      </Head>
      <Metatags
        metaTitle={title}
        metaDescription={metaDescription}
        metaImageUrl={product.images.length > 0 ? product.images[0].url : null}
      />
      <ProductSchema
        name={product.title}
        brand={product.brand}
        colour={product.colour}
        size={product.size}
        price={product.price}
        imageURL={product.images.length > 0 ? product.images[0].url : null}
      />
      {product.images.length > 0 && (
        <Box display={["none", null, "block", null]}>
          <ProductImagesFullScreen
            images={product.images}
            productSpinImages={product.productSpinImages}
            brandImages={product.brandImages}
          />
        </Box>
      )}
      <Box>
        <BoxWithGutter mt={[33, null, 50, null]}>
          <BackButton />
        </BoxWithGutter>
        <BoxWithGutter
          display={[null, null, "grid", null]}
          gridTemplateColumns={[null, null, "1fr 1fr", null]}
          gridColumnGap={[null, null, "2.38vw", null]}
          pt={[null, null, 50, null]}
          pb={[50, null, 100, null]}
        >
          <ProductImagesDesktop
            images={product.images}
            productSpinImages={product.productSpinImages}
            brandImages={product.brandImages}
          />
          <Box display="flex" justifyContent="center">
            <Box
              width="100%"
              maxWidth={[null, null, 480, null]}
              pt={[null, null, 80, null]}
              position={[null, null, "sticky", null]}
              alignSelf="flex-start"
              top={0}
            >
              <Box mt={[30, null, 0, null]}>
                <ProductDetails product={product} />
              </Box>

              <ProductImagesMobile
                images={product.images}
                productSpinImages={product.productSpinImages}
                brandImages={product.brandImages}
              />
              {product.available ? (
                <AddToCartButton variantId={product.variantId} />
              ) : (
                <BodyText>No longer available</BodyText>
              )}

              {product.brand.sizeFitUrl && (
                <Box mt={[27, null, 40, null]}>
                  <SizeAndFit href={product.brand.sizeFitUrl} />
                </Box>
              )}
              {product.conditionNotes && (
                <ProductNotes
                  label="Condition notes"
                  conditionNotes={product.conditionNotes}
                />
              )}
              {product.repairNotes && (
                <ProductNotes
                  label="Repair notes"
                  conditionNotes={product.repairNotes}
                />
              )}
              <Box mt={40}>
                <DeliveryAndReturns />
              </Box>
              <Box mt={[22, null, 32, null]}>
                <TrustBar />
                {(product.water || product.cO2) && (
                  <SustainabilityCredentials
                    water={product.water}
                    cO2={product.cO2}
                  />
                )}
              </Box>
            </Box>
          </Box>
        </BoxWithGutter>
      </Box>
    </>
  );
}

export default Product;
